import React from "react";
import LoginSignUpSection from "./../components/LoginSignUpSection";
import { useRouter } from "./../util/router.js";

function LoginSignupPage(props) {
  const router = useRouter();
  return (
    <LoginSignUpSection
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      title="Create an account"
      subtitle=""
      buttonText="Sign up"
      inputSize="lg"
      afterAuthPath={router.query.next || "/dashboard"}
    ></LoginSignUpSection>
  );
}

export default LoginSignupPage;
